import { graphql } from "relay-runtime"

export const chReferralLetterFragment = graphql`
  fragment chReferralLetterFragment on ch_ReferralLetter {
    id
    progressNoteId
    createdAt
    createdBy
    fileId
    patientId
    reasoning
    referralId
    signedAt
    signedBy
    concludedAt
    concludedBy
    updatedAt
    updatedBy
    medicationIds
    conditions
    allergies
    documentLanguage
    careProviderIds
    careProvidersCopyTo {
      id
    }
    icdDiagnosis {
      id
      isAssociation
      diagnosisCode
      primaryCode
      secondaryCode
      associationType
      text
    }
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
